<div [class.aligned-top]="alignedTop"
     [class.anchored-top]="anchoredTop"
     [class.close]="!isOpenWithAnimationDelay"
     [class.open]="isOpenWithAnimationDelay"
     [class.scrollable-body]="scrollableBody"
     [id]="modalId"
     aria-labelledby="modalTitle"
     aria-modal="true"
     class="work-ui-modal">
  <div [class]="modalWidth"
       class="work-ui-modal__container"
       tabindex="-1">
    <div #modalCard
         [class.no-inline-borders]="!showInlineBorders"
         class="work-ui-modal__content work-card no-padding">
      <div [class.border-bottom]="showInlineBorders"
           [class.padding-none]="!titleText && !introText"
           class="work-ui-modal__header">
        <div class="work-ui-modal__header-text">
          <h2 id="modalTitle">{{ titleText | translate }}</h2>
          @if (introText) {
            <p>{{ introText | translate }}</p>
          }
        </div>
        @if (!hideCloseButton) {
          <work-ui-button (click)="close(true)"
                          [iconOnly]="true"
                          [size]="modalWidth === 'small' ? 'small' : 'default'"
                          [attr.aria-label]="'SCHLIESSEN' | translate"
                          class="work-ui-modal__header-close-button"
                          iconName="close"
                          variant="secondary">
          </work-ui-button>
        }
      </div>

      <div #modalBody [class.padding-bottom-32]="noFooter"
           [class.padding]="!noBodyContent && !noBodyPadding"
           [class.work-ui-modal__body--no-padding-horizontal]="noBodyPaddingHorizontal"
           [class.work-ui-modal__body--no-padding]="noBodyPadding"
           class="work-ui-modal__body">
        <ng-content select="[modal-body]"></ng-content>
        <ng-template #dynamicComponentSlot></ng-template>
      </div>

      <!-- Modal Footer (if needed, in case of forms, put buttons inside form of modal__body) -->
      <div [class.border-top]="showInlineBorders" class="work-ui-modal__footer">
        <ng-content select="[modal-footer]"></ng-content>
        <!--      Only use buttons here, example:-->
        <!--      <ng-container modal-footer>-->
        <!--        <work-ui-button text="Speichern" (click)="demoModal.close(); isModalOpen = false"></work-ui-button>-->
        <!--        <work-ui-button text="Schliessen" variant="secondary" (click)="demoModal.close(); isModalOpen = false"></work-ui-button>-->
        <!--      </ng-container>-->
      </div>
    </div>
  </div>
</div>
